import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import { parseQueryString } from '../../../../lib/common';
import { ACCOUNT_USER_DETAIL_TAB_KEY } from '../../../../constants/service/app/accountUserConstants';
import { useNavigate } from 'react-router-dom';

export const useCurrentTab = () => {
  const [currentTab, setCurrentTab] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const currentTabKey = parseQueryString();

    setCurrentTab(
      !isEmpty(currentTabKey) && Object.values(ACCOUNT_USER_DETAIL_TAB_KEY).includes(currentTabKey.tabKey)
        ? currentTabKey.tabKey
        : ACCOUNT_USER_DETAIL_TAB_KEY.USER_INFO,
    );
  }, []);

  const setTabKey = (tabKey) => {
    const tabKeyString = String(tabKey);

    if (Object.values(ACCOUNT_USER_DETAIL_TAB_KEY).includes(tabKeyString)) {
      navigate(`?tabKey=${tabKeyString}`);
    }

    setCurrentTab(tabKey);
  };

  return { currentTab, setTabKey };
};
